// extracted by mini-css-extract-plugin
export var currencyInput = "_n3-1";
export var currencySymbol = "_n3-0";